import { FC, useContext, useMemo } from 'react';
import { Avatar, Stack } from '@mui/material';
import { Campaign } from '@mui/icons-material';

import ErrorBoundary from '@cvt/components/ErrorBoundary';
import { DialogContext } from '@cvt/contexts';
import { useDictionary } from '@cvt/hooks/useDictionary';

import { useMe } from '@modules/Auth/hooks/useMe';
import { PreferenceVersionSummary } from '@modules/Users/partials/PreferenceVersionSummary';
import { PreferenceCard } from '@modules/Users/components/PreferenceCard';


export const CurrentValues: FC = () => {

  const { openDialog } = useContext(DialogContext);
  const dictionary = useDictionary();

  const { user } = useMe();

  const values = useMemo(() => {
    const { preferences } = user || {};
    return [
      preferences?.leadershipValue1,
      preferences?.leadershipValue2,
      preferences?.leadershipValue3,
    ].filter(Boolean) as string[];
  }, [user]);

  return (
    <Stack gap={{ xs: 6, sm: 2 }}>
      <PreferenceCard
        title={dictionary.values.title}
        subtitle={dictionary.values.subtitle}
        onEdit={() => openDialog('editLeadershipValues', { user })}
        icon={
          <Avatar
            variant="rounded"
            sx={{ bgcolor: 'primary.main' }}
          >
            <Campaign sx={{ fontSize: 24 }}/>
          </Avatar>
        }
        items={values}
      />

      <ErrorBoundary message={dictionary.preferences.versionSummary.emptyHistory}>
        <PreferenceVersionSummary createdLabel={dictionary.values.createdLabel}/>
      </ErrorBoundary>
    </Stack>
  );
};